import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../Core/store.hooks";
import { filterBy } from "@progress/kendo-data-query";
import {
  ComboBox,
  DropDownList,
  ComboBoxChangeEvent,
  ComboBoxFilterChangeEvent,
  DropDownListChangeEvent,
  MultiSelect,
  MultiSelectChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { CustomerListApi } from "./api";
import {
  loginSelector,
  loadingLoginSelector,
  errorLoginSelector,
} from "../Core/Slice";

type handler = () => void;
interface settingsProps {
  addColumn: any;
}

const AddColumn= (props: settingsProps) => {
    const authResponse = useSelector(loginSelector);
    const [headersFetched, updateHeadersFetched] = useState(false);
    const [headers, updateHeaders] = useState([]);
    const [header, updateHeader] = useState(null);
    const [headerStrings, updateHeaderStrings] = useState([]);
    const [headerStringsAll, updateHeaderStringsAll] = useState([]);
    const [loadingHeaders, updateHeadersLoading] = useState(false);

    const [groups, updateGroups] = useState([]);
    const [group, updateGroup] = useState(null);
    const [groupId, updateGroupId] = useState("");
    const [groupStrings, updateGroupStrings] = useState([]);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!props.visible) {
            updateHeaders([]);
            updateHeaderStrings([]);

            updateGroup(null);
            updateGroupId("");
            updateHeader(null);
        }

        if (authResponse && !headersFetched) {
            fetchGroups();
        }
    }, [props.visible, authResponse]);

    useEffect(() => {
        if (groupId != "" && groupId != null) {
            fetchHeaders();
            updateHeaders([]);
            updateHeaderStrings([]);
            updateHeaderStringsAll([]);
            updateHeader(null);
        }
    }, [groupId]);

    const fetchHeaders = () => {
        updateHeadersLoading(true);
        CustomerListApi.getHeaders({ groupId: groupId }).then((response: any) => {
            if (response != null && response != undefined) {
                const headerStrings = response.map((item) => item.infoHeaderName);
                updateHeaders(response);
                updateHeaderStrings(headerStrings);
                updateHeaderStringsAll(headerStrings);
               // console.log(headers);

                updateHeadersLoading(false);
            }
        });
    };
    const fetchGroups = () => {
        CustomerListApi.getHeaderGroups().then((response: any) => {
            if (response != null && response != undefined) {
                const groupStrings = response.map((item) => item.infoGroupName);
                updateGroups(response);
                updateGroupStrings(groupStrings);
               // console.log(groups);
                updateHeadersFetched(true);
            }
        });
    };
    const onChange = (event: any) => {
        for (var i = 0; i < headers.length; i++) {
            if (headers[i].infoHeaderName == event.target.value) {
                updateHeader(event.target.value);
            }
        }
    };
    const onGroupChange = (event: any) => {
        if (event.target.value == null) {
            updateGroup(null);
        }
        for (var i = 0; i < groups.length; i++) {
            if (groups[i].infoGroupName == event.target.value) {
                updateGroup(event.target.value);
                updateGroupId(groups[i].infoGroupId);
            }
        }
    };

    const comboBoxFilters = () => {
        return {
            headers: (event: ComboBoxFilterChangeEvent) => {
                updateHeaderStrings(filterBy(headerStringsAll, event.filter));
            },
        };
    };

    const renderFilter = () => {
        return (
            <>
                <div className=" k-textbox-container metricCombo">
                    <label className="k-label" style={{ color: "#2b2b2b" }}>
                        Select Header Group
                    </label>
                    <ComboBox
                        popupSettings={{ width: "auto" }}
                        data={groupStrings}
                        value={group}
                        onChange={onGroupChange}
                        suggest={true}
                        filterable={true}
                    //onFilterChange={comboBoxFilters().headerStrings}
                    />
                </div>
                <div className=" k-textbox-container metricCombo">
                    <label className="k-label" style={{ color: "#2b2b2b" }}>
                        Select Header
                    </label>
                    <ComboBox
                        popupSettings={{ width: "auto" }}
                        data={headerStrings}
                        value={header}
                        onChange={onChange}
                        suggest={true}
                        filterable={true}
                        onFilterChange={comboBoxFilters().headers}
                        loading={loadingHeaders}
                    //onFilterChange={comboBoxFilters().headerStrings}
                    />
                </div>
            </>
        );
    };
    const addColumn = () => {
        if (header != null) {
            for (var i = 0; i < headers.length; i++) {
                if (headers[i].infoHeaderName == header) {
                    props.addColumn(headers[i].infoHeaderId, headers[i].infoHeaderName);
                    break;
                }
            }
        }
    };
    const renderAddButton = () => {
        let buttonStyle: any = {};
        if (header == null) buttonStyle = { backgroundColor: "#ccc" };
        return (
            <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                style={buttonStyle}
                onClick={() => addColumn()}
            >
                Add Column
            </button>
        );
    };

    return (

        <div style={{ padding: "10px", margin: "10px", border: "solid 1px #ccc" }}>
                <p>Add New Column</p>
            {renderFilter()}
            {renderAddButton()}
        </div>

    );
}


export default AddColumn;
